/**
 * Shared controller series display order.
 * Mirrors SortOrderConfig::CONTROLLER_SERIES in PHP.
 * Lower numbers appear first.
 */
export const CONTROLLER_DISPLAY_ORDER = {
  'R-50iA': 10,
  'R-30iB Plus': 20,
  'R-30iB': 30,
  '30i': 40,
  '31i-WB': 50,
  '31i': 55,
  '32i': 60,
  '0i': 70,
};

/**
 * Sort controller series names by display order (newest first).
 * Unknown entries fall to the end.
 */
export function sortControllerSeries(controllers) {
  if (!controllers || !Array.isArray(controllers)) return [];
  return [...controllers].sort((a, b) => {
    const orderA = CONTROLLER_DISPLAY_ORDER[a] ?? 999;
    const orderB = CONTROLLER_DISPLAY_ORDER[b] ?? 999;
    return orderA - orderB;
  });
}
